import { render, staticRenderFns } from "./AccessAdmin.vue?vue&type=template&id=f19b7054"
import script from "./AccessAdmin.vue?vue&type=script&lang=js"
export * from "./AccessAdmin.vue?vue&type=script&lang=js"
import style0 from "./AccessAdmin.vue?vue&type=style&index=0&id=f19b7054&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports